import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class Global {
     
     userToken: string = null;
     User: any = [];
     CanWrite = false;
     IsLoaderOn = true;
     auditTrailId: string;
     auditTrailClass: string;
     RolesList: any;
     IsAdmin = false;
     IsZoneHead = false;
     IsLocationHead = false;
     IsOfficeHead = false;
     IsQBROwner = false;
     IsUser = false;
     loading = false;
     CurrentRole: string;
     EmailPattern =
          '^[a-zA-Z]{1}[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]{3}|[a-zA-Z]{1}[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+.[a-zA-Z0-9]{2}$';
     IsAuditVisible = false;
     CurrentYear: Number = new Date().getFullYear();
     pageIndex = 1;
     length = 0;
     totalPage = 0;
     RecordSize = 10;
     IsConsent: boolean;
     SecondaryHeadBtnVisible = false;  
     ShowAlert(msg: string) {
          alert(msg);
     }

}
